<template>
  <Card :class="$style.container">
    <div
      :class="$style.buttonHeaderRow"
      data-test-id="FloatingFixedBottomCard__closeSlot"
    >
      <slot name="close">
        <ButtonClose
          data-test-id="FloatingFixedBottomCard__closeButton"
          @click="handleClose"
        />
      </slot>
      <slot name="leftAction" />
    </div>
    <div data-test-id="FloatingFixedBottomCard__contentSlot">
      <slot />
    </div>
  </Card>
</template>

<script>
import {
  ButtonClose,
  Card,
} from '@jumpcloud/ui-components';

export default {
  name: 'FloatingFixedBottomCard',

  components: {
    ButtonClose,
    Card,
  },

  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped module>
.buttonHeaderRow {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.container {
  bottom: 0;
  box-shadow: var(--jc-box-shadow-card);
  display: flex;
  flex-direction: column;
  gap: var(--jc-spacer);
  left: 0;
  position: absolute;
  width: 100%;

  /* making sure card is displayed over tooltips in pricing page */
  z-index: 600;
}
</style>
